function Gallery(){
    return (
        <section className="gallery">
            <div className="gallery--img gallery--milk"></div>
            <div className="gallery--img gallery--orange"></div>
            <div className="gallery--img gallery--cone"></div>
            <div className="gallery--img gallery--sugar-cubes"></div>
        </section>
    )
}
export default Gallery;